function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import MainPanel from '../../../MainPanel';
import './Workflow.css';

var Workflow = /*#__PURE__*/function (_React$Component) {
  _inherits(Workflow, _React$Component);

  function Workflow(props) {
    var _this;

    _classCallCheck(this, Workflow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Workflow).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "headerTitle", function () {
      var panelNames = _this.props.panelNames;
      var activePanelIndex = _this.state.activePanelIndex;
      return panelNames[activePanelIndex] || '';
    });

    _this.state = {};
    return _this;
  }

  _createClass(Workflow, [{
    key: "render",
    value: function render() {
      var headerTitle = this.headerTitle;
      var _this$props = this.props,
          app = _this$props.app,
          width = _this$props.width,
          height = _this$props.height,
          show = _this$props.show,
          onBack = _this$props.onBack,
          onForward = _this$props.onForward,
          activePanelIndex = _this$props.activePanelIndex;
      return React.createElement("div", {
        className: "workflow ".concat(this.props.show ? 'show' : ''),
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "header"
      }, React.createElement("div", {
        className: "btn ripple",
        onClick: function onClick(e) {
          e.target.blur();
          onBack();
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: activePanelIndex === 0 ? faTimes : faChevronLeft
      })), React.createElement("div", {
        className: "title"
      }, headerTitle()), React.createElement("div", {
        className: "btn right ripple",
        onClick: function onClick(e) {
          e.target.blur();
          onForward();
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faChevronRight
      }))), React.createElement(MainPanel, {
        activePanelIndex: activePanelIndex,
        width: width,
        height: height - 65
      }, this.props.panels));
    }
  }]);

  return Workflow;
}(React.Component);

export default Workflow;